export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1024w.3b04dc8a.avif";